import {ClassroomModelV1} from 'resources/GeneratedModels/Classroom/ClassroomModel.v1';
import extensions from './classroom.extensions';

ClassroomModelV1.extend(extensions);

export {ClassroomModelV1};
